import React from 'react'
import GoogleSheets from '../../../../../components/GoogleSheets/GoogleSheets'

const ActualsGoogleSheets = () => {
  return <GoogleSheets type="actuals" />
}

export default ActualsGoogleSheets
